module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-multi-2a228ba5666627d5d2142ced51f44cbd.png";